import { Children, Fragment, isValidElement } from "react";

type ReactChildArray = ReturnType<typeof Children.toArray>;
/**
 * More performant version of the npm package `react-flatten-library`. This will only flatten the top level and use
 * `.flatMap` instead of `.reduce`
 *
 * This will flatten flatten any `React.Fragment` that is in children so that a child of `React.Fragment` is moved to the top level children.
 * */
export function flattenChildren(children: React.ReactNode): ReactChildArray {
    const childrenArray = Children.toArray(children);
    return childrenArray.flatMap((child) => {
        const isFragment = (
            reactChild: any
        ): reactChild is React.ReactElement =>
            isValidElement(reactChild) &&
            (reactChild as React.ReactElement<{ children: React.ReactNode }>)
                .type === Fragment;

        if (isFragment(child)) {
            return child.props.children;
        }

        return child !== null ? [child] : [];
    });
}
